import { render, staticRenderFns } from "./languageSwitcher.vue?vue&type=template&id=72d4a8b4&scoped=true&"
import script from "./languageSwitcher.vue?vue&type=script&lang=js&"
export * from "./languageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./languageSwitcher.vue?vue&type=style&index=0&id=72d4a8b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d4a8b4",
  null
  
)

export default component.exports